module.exports = __webpack_public_path__ + "src/img/cloud.a686cbcc.png";